import { ConditionalRule } from './enums'

function getIterationMethod(conditionRule?: ConditionalRule): 'some' | 'every' | null {
  if (conditionRule === ConditionalRule.OR) {
    return 'some'
  }

  if (conditionRule === ConditionalRule.AND) {
    return 'every'
  }

  if (conditionRule === ConditionalRule.None) {
    return null
  }

  return 'some'
}

export default getIterationMethod
